export default {
  "hero.eyebrow": "CENTRO DE RECURSOS DE LA HOJA USFANS",
  "hero.title": "Hoja USFans — Encuentra productos, enlaces y guías de compra más inteligentes",
  "hero.description": "Explora la hoja de USFans, descubre enlaces útiles de productos, compara categorías, comprende el control de calidad y el envío, y toma mejores decisiones de compra con nuestro centro de recursos independiente.",
  "hero.trust": "Recurso independiente • Guías actualizadas • Soporte multilingüe",
  "hero.buyNow": "Comprar ahora",
  "hero.explore": "Explora la hoja de USFans",

  "dropdown.label": "Elige una categoría",
  "dropdown.placeholder": "Selecciona una categoría para ir al sitio principal",

  "categories.title": "Explora las categorías de la hoja USFans",
  "categories.description": "Elige una categoría a continuación para abrir la sección correspondiente en el sitio principal. Cada botón te lleva directamente a los productos que quieres ver.",

  "about.title": "¿Qué es la hoja USFans?",
  "about.p1": "La hoja USFans es un recurso estructurado para descubrir productos. En lugar de abrir decenas de pestañas, reúne enlaces, categorías, imágenes y notas en un solo lugar para que explores, compares y avances más rápido.",
  "about.p2": "Piensa en ella como una sola tabla donde cada fila es un producto y cada columna contiene un detalle útil: la categoría, el nombre, el enlace y notas extra. Al estar agrupado por categoría, puedes saltar entre zapatos, sudaderas, camisetas, chaquetas y accesorios sin perder el hilo.",
  "about.p3": "Una buena hoja también te ayuda a pensar antes de comprar. Puedes revisar las fotos de control de calidad, consultar los detalles de envío y comparar varias opciones antes de comprometerte con un pedido.",
  "about.cta": "Descubre cómo funciona la hoja USFans",

  "guide.title": "Cómo usar la hoja",
  "guide.step1.title": "Elige una categoría",
  "guide.step1.desc": "Empieza por la sección que coincida con lo que buscas, desde zapatos hasta accesorios.",
  "guide.step2.title": "Explora y compara",
  "guide.step2.desc": "Lee los nombres, enlaces y notas para preseleccionar los productos que se adaptan a ti.",
  "guide.step3.title": "Revisa los detalles",
  "guide.step3.desc": "Consulta precio, tallas, fotos de control de calidad y envío antes de decidir.",
  "guide.step4.title": "Abre el producto",
  "guide.step4.desc": "Haz clic para ir al sitio principal, ver el listado completo y completar tu pedido.",

  "cards.title": "Guías e información de USFans",
  "cards.description": "Guías independientes y honestas para entender la hoja, el envío, el control de calidad y más antes de comprar.",
  "card.review.title": "Reseña de USFans",
  "card.review.desc": "Un panorama independiente que cubre pedidos, almacén, control de calidad, envío y la experiencia general del cliente.",
  "card.shipping.title": "Costo de envío de USFans",
  "card.shipping.desc": "Comprende cómo el peso, las dimensiones, el destino y el método de envío afectan tu costo total.",
  "card.coupon.title": "Cupón de USFans",
  "card.coupon.desc": "Aprende a encontrar y verificar ofertas de cupones actuales antes de usarlas.",
  "card.discount.title": "Código de descuento de USFans",
  "card.discount.desc": "Entiende las condiciones de los códigos y cómo comprobar si una oferta sigue vigente.",
  "card.warehouse.title": "Almacén de USFans",
  "card.warehouse.desc": "Conoce el almacenamiento, el control de calidad, la consolidación y cómo se preparan los paquetes antes del envío.",
  "card.legit.title": "¿Es legítimo USFans?",
  "card.legit.desc": "Revisa la confianza, seguridad, pagos, envío y factores del vendedor antes de pedir.",

  "articleCta.title": "Lee nuestra guía para principiantes",
  "articleCta.desc": "¿Nuevo en la hoja USFans? Empieza con nuestra guía original y completa sobre su funcionamiento, control de calidad, costos de envío y cómo comprar con seguridad.",
  "articleCta.button": "Leer la guía completa",

  "finalCta.title": "¿Listo para explorar la hoja USFans?",
  "finalCta.desc": "Empieza con la hoja, compara la información que importa y usa nuestras guías antes de decidir.",
  "finalCta.button": "Explora la hoja USFans",

  "category.shoes": "Zapatos",
  "category.hoodies": "Sudaderas / Suéteres",
  "category.tshirts": "Camisetas",
  "category.jackets": "Chaquetas",
  "category.pants": "Pantalones / Pantalones cortos",
  "category.headwear": "Gorras y sombreros",
  "category.sets": "Conjuntos",
  "category.underwear": "Ropa interior / Calzoncillos",
  "category.jersey": "Camiseta deportiva",
  "category.accessories": "Accesorios",
  "category.bags": "Bolsos",
  "category.belts": "Cinturones",
  "category.perfumes": "Perfumes",
  "category.other": "Otras cosas",

  "pillars.title": "Guías de la hoja USFans",
  "pillars.desc": "Guías independientes y detalladas para entender cada aspecto de la experiencia con la hoja USFans.",
  "pillar.spreadsheet.title": "Guía de la hoja",
  "pillar.spreadsheet.desc": "Qué es la hoja USFans, cómo funciona y cómo usarla paso a paso.",
  "pillar.review.title": "Reseña de USFans",
  "pillar.review.desc": "Pedidos, almacén, QC, envío y experiencia general del cliente.",
  "pillar.shipping.title": "Costo de envío",
  "pillar.shipping.desc": "Cómo el peso, las dimensiones y el transportista afectan el costo.",
  "pillar.coupon.title": "Guía de cupones",
  "pillar.coupon.desc": "Cómo encontrar y verificar cupones de USFans antes de usarlos.",
  "pillar.discount.title": "Código de descuento",
  "pillar.discount.desc": "Validez, condiciones y cómo aplicar códigos en el checkout.",
  "pillar.warehouse.title": "Guía del almacén",
  "pillar.warehouse.desc": "Almacenamiento, QC, consolidación y preparación de paquetes.",
  "pillar.legit.title": "¿Es legítimo USFans?",
  "pillar.legit.desc": "Seguridad, pagos y factores de confianza antes de pedir.",
  "pillar.qc.title": "Guía de QC",
  "pillar.qc.desc": "Cómo leer fotos de control de calidad y qué verificar antes de aprobar.",
  "pillar.beginner.title": "Guía para principiantes",
  "pillar.beginner.desc": "Tu primer pedido en USFans desde la cuenta hasta la entrega.",
  "pillar.safety.title": "Guía de seguridad",
  "pillar.safety.desc": "Precauciones esenciales para proteger tu cuenta, pagos y privacidad.",

  "readMore": "Leer más",
};